import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../../App.css";
import "./Navigation.css";
import SideNavigation from "./SideNavigation";
import TopNavigation from "./TopNavigation";
import Footer from "./Footer";
import Routes from "./Routes";
import { cancelPendingRequests } from "../utils/requestCancellation";
import axios from "axios";

const routeMeta = {
  "/dashboard": ["Operations Overview", "Ringkasan aktivitas lintas platform dan transaksi"],
  "/sla-aging": ["SLA & Aging", "Pantau item tertahan dan kepatuhan waktu proses"],
  "/executive-report": ["Executive Report", "Ringkasan performa bisnis dengan periode lintas sumber yang seragam"],
  "/merchant": ["Merchant", "Kelola informasi dan admin fee merchant"],
  "/merchant/performance": ["Performa Merchant", "Analisis omzet dan kualitas transaksi merchant"],
  "/audit-log": ["Audit Log", "Riwayat aktivitas administrator dan perubahan data"],
  "/user-access": ["User Access", "Tambah administrator dan atur akses menu per user"],
  "/cekgudang/companies": ["Daftar Company SCM 360", "Company yang terdaftar pada ekosistem SCM 360"],
  "/transaction": ["Daftar Transaksi", "Pantau invoice dan status pembayaran"],
  "/reportinvoice": ["Laporan Invoice", "Analisis dan rekap invoice"],
  "/reportinvoicefull": ["Laporan Invoice Lengkap", "Detail seluruh aktivitas invoice"],
  "/refund": ["Refund", "Kelola transaksi pengembalian dana"],
  "/checkpayout": ["Pemeriksaan Payout", "Tinjau permintaan pencairan dana"],
  "/approvepayout": ["Persetujuan Payout", "Proses persetujuan pencairan dana"],
  "/reportpayout": ["Laporan Payout", "Rekap aktivitas pencairan dana"],
  "/reportpembayaran": ["Laporan Pembayaran YPL", "Pantau laporan pembayaran dari database YPL"],
  "/reportpembayaran-general": ["Laporan Pembayaran General", "Pantau laporan pembayaran dari database General"],
  "/calendar": ["Kalender", "Jadwal aktivitas operasional terintegrasi"],
  "/bursa-kopi/merchant": ["Merchant Bursa Kopi", "Kelola informasi dan admin fee merchant Bursa Kopi"],
  "/bursa-kopi/merchant/performance": ["Performa Merchant Bursa Kopi", "Analisis omzet dan kualitas transaksi Bursa Kopi"],
  "/bursa-kopi/transaction": ["Transaksi Bursa Kopi", "Pantau invoice dan status pembayaran Bursa Kopi"],
  "/bursa-kopi/reportinvoice": ["Laporan Invoice Bursa Kopi", "Analisis dan rekap invoice Bursa Kopi"],
  "/bursa-kopi/reportinvoicefull": ["Laporan Lengkap Bursa Kopi", "Detail seluruh aktivitas invoice Bursa Kopi"],
  "/bursa-kopi/refund": ["Refund Bursa Kopi", "Kelola transaksi pengembalian dana Bursa Kopi"],
  "/bursa-kopi/checkpayout": ["Pemeriksaan Payout Bursa Kopi", "Tinjau permintaan pencairan dana Bursa Kopi"],
  "/bursa-kopi/approvepayout": ["Persetujuan Payout Bursa Kopi", "Proses persetujuan pencairan dana Bursa Kopi"],
  "/bursa-kopi/reportpayout": ["Laporan Payout Bursa Kopi", "Rekap aktivitas pencairan dana Bursa Kopi"],
};

class RoutesWithNavigation extends Component {
  state = {
    windowWidth: window.innerWidth,
    sideNavOpen: false,
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.unlistenHistory = this.props.history.listen(() => {
      cancelPendingRequests();
    });
    axios.get(global.variable.LINK_API + "auth/user", global.variable.HEADERS_BEARER)
      .then(response => {
        localStorage.setItem("admin_user", JSON.stringify(response.data.data || null));
        localStorage.setItem("menu", JSON.stringify(response.data.menu || []));
        this.forceUpdate();
      })
      .catch(() => {});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname && this.state.sideNavOpen) {
      this.setState({ sideNavOpen: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    if (this.unlistenHistory) this.unlistenHistory();
    cancelPendingRequests("SPIN Management Portal ditutup.");
  }

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  toggleSideNav = () => {
    this.setState(currentState => ({ sideNavOpen: !currentState.sideNavOpen }));
  };

  closeSideNav = () => {
    this.setState({ sideNavOpen: false });
  };

  getRouteMeta = () => {
    const { pathname } = this.props.location;

    if (pathname.indexOf("/bursa-kopi/transactiondetail/") === 0) {
      return ["Detail Invoice Bursa Kopi", "Informasi lengkap transaksi dan pembayaran Bursa Kopi"];
    }

    if (pathname.indexOf("/transactiondetail/") === 0) {
      return ["Detail Invoice", "Informasi lengkap transaksi dan pembayaran"];
    }

    if (pathname.indexOf("/reportpembayaran-general/detail/") === 0) {
      return ["Detail Pembayaran General", "Informasi pembayaran Kliksekolah dari database General"];
    }

    return routeMeta[pathname] || ["Management Portal", "Unified administration workspace"];
  };

  render() {
    const isMobile = this.state.windowWidth < 1000;
    const [routeName, routeDescription] = this.getRouteMeta();

    return (
      <div className="admin-shell">
        <SideNavigation
          isMobile={isMobile}
          isOpen={!isMobile || this.state.sideNavOpen}
          onLinkClick={this.closeSideNav}
          onClose={this.closeSideNav}
        />
        <div className="admin-shell__content">
          <TopNavigation
            routeName={routeName}
            routeDescription={routeDescription}
            onSideNavToggleClick={this.toggleSideNav}
          />
          <main className="admin-main">
            <Routes />
          </main>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(RoutesWithNavigation);
